module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center1",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('strong', [_c('em', [_vm._v("“Cultivators of the earth are the most valuable citizens. They are the most vigorous, the most independent, the most virtuous, and they are tied to their country and wedded to its liberty and interests by the most lasting bands.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("Thomas Jefferson")]), _vm._v(" "), _c('p', {
    staticClass: "chaptitle"
  }, [_c('strong', [_vm._v("1.")])]), _vm._v(" "), _c('p', {
    staticClass: "chaptitle1"
  }, [_c('strong', [_vm._v("COMPOSTING = STEWARDSHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "29",
      "src": "images/commonr.jpg",
      "width": "30"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Every successful venture begins with a healthy foundation. Before we can grow food, we have to grow soil—and lots of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I make good dirt for a living. I also make it at home, every day, beginning in the morning when I toss the grounds from my coffee and the banana peel from my smoothie into the compost caddy by the sink. When it’s full, I dump it into the backyard compost bin. Over a period of weeks and months, billions of bugs, bacteria, and fungi will convert these stinky, rotten kitchen scraps mixed with yard debris into fertile, sweet-smelling, life-giving earth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soil is the skin around our earth and the source of our sustenance, where life starts and finishes. Yet most of us take this vital resource for granted. Much of our earth has been degraded, overfarmed, and undernourished for many decades. We are currently losing topsoil faster than we can regenerate it. Millions of tons of organic materials that could be composted are taking up valuable space in landfills, rather than being returned to farms to grow healthy food.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Replenishing soil is just one of the many positive outcomes of composting. This practice can also drastically reduce, if not eliminate, the need for petroleum-based fertilizers, which pollute soil, air, water, animals, and humans. Compost builds the organic matter in soil, which helps plants grow strong and increase resistance to pests, disease, and drought.")]), _vm._v(" "), _c('p', {
    staticClass: "image-b"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0021-01.jpg",
      "width": "437"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-ba",
    attrs: {
      "id": "ch01image1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0022-01.jpg",
      "width": "437"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("Composting is a daily reminder of our individual tasks as citizen farmers: contributing to a healthy planet and being a responsible steward of the land. In this chapter, I hope to inspire you to make composting as essential to your daily routine as brushing your teeth. I want to share with you some very important tips on how to make your soil thrive so the food you grow helps you to thrive, too.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("LOVE AT FIRST SCOOP")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Until college, I never thought twice about tossing table scraps anywhere other than in a trash can or down a garbage disposal. It was shortly after my turkey sandwich revelation when someone I met at a party told me about an introductory workshop on biodynamic farming that was coming up at the Michael Fields Institute, about an hour from Madison. Founded in 1984, this nonprofit organization is one of the cornerstones of the biodynamic movement in the United States, with the mission of promoting sustainable agriculture through education, research, and outreach. There, I studied under several composting gurus who changed the way I thought about “dirt” forever.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Under their guidance, about a dozen farming newbies, including myself, learned how to build a biodynamic compost pile with garden refuse, dairy manure, spent hay, and a little soil from the garden. We spent a grueling day shoveling and spreading layers of this organic matter as if making a monster-size batch of lasagna. As the pile grew taller, we leaned a huge wooden board against the pile so we could run the wheelbarrow up to dump more materials on top. By the end of the day, our pile had grown to the size of a pickup truck. We covered it all with a layer of straw and doused it heavily with water, using a hose with a shower nozzle to replicate falling rain. Then we put holes in the pile at the locations specified in the biodynamic agriculture lectures by Rudolf Steiner, and added the requisite biodynamic compost preparations. The workshop was over, and now it was time to let Mother Nature work her magic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had dipped my toe into biodynamic farming and was now officially on my way to becoming a true citizen farmer.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("DOWN THE RABBIT HOLE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Back at school, I scoured a list of local organic farms put out by the university’s agriculture school and started calling them to see which ones offered apprenticeships.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then I met Greg David, a former commercial builder turned organic farmer who occupied a bubble of "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("biodiversity in the midst of an endless, sterile monoculture of corn crops about forty-five minutes from Madison. Greg hired me, and for the next six months I rose at the crack of dawn every day to drive from Madison to Greg’s farm to work until dark—for fifty bucks a week.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Greg was especially passionate about restoring what had been a monoculture field of corn into a vibrant native prairie in order to create a sanctuary for wildlife in this agricultural desert. I helped him do this by preparing the ground and seeding it with a nurse crop of sunflowers that would provide shade and eclipse the weeds. Once the prairie was established, we would burn it periodically to maintain the revitalized soil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Greg also had cutting-edge ideas about composting. He formed a relationship with the Department of Natural Resources and they would bring him truckload after truckload of fallen leaves and mucked-up lake weeds that would get dumped on the farm into long windrows. He was essentially harvesting all the organic matter from the region, composting it, and building up the soil fertility of his farm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once the mountains of leaves and lake weeds reached a certain size, he would fence his fifteen or twenty Tamworth pigs in around these piles. One of my jobs was to walk across each pile with a can of dried corn kernels and a shovel handle, and every 10 feet or so make a 3-foot-deep hole and drop a handful of corn down it. The pigs would root for the corn, and turn the compost in the process. When the pigs weren’t being used to turn the piles, we would set them out to plow the fields by uprooting and eating the quack grass, which they could do better than any tractor. Not only did the pigs completely clean the fields of this pervasive weed, but they simultaneously fertilized the fields, saving us from driving the tractor all over them, compacting the soil, and burning fossil fuels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have a memory of walking the compost piles in the rain, collecting a bumper crop of the most beautiful volunteer tomatoes, peppers, and squash—plants that had sprouted voluntarily from the seeds of rotting fruit that had been turned by the pigs in this unbelievably fertile compost pile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had never before seen composting in action on that scale, and it was revelatory. This was biodynamic farming at its best, where animals were integrated into the agricultural organism in a humane and productive fashion, and the spoils of fallen leaves and rotting vegetables could be transformed into fertility for the land and an abundant harvest of food for the CSA.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('strong', [_vm._v("BIODYNAMICS: A VEHICLE FOR ACTION")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Armed with the basic tools for becoming an organic farmer, I was beginning to see a career path for myself that did not involve academia. After my awe-inspiring internship with Greg, I decided to withdraw from school and take on another apprenticeship instead, this time on a full-blown biodynamic farm in the North Georgia Mountains, run by Hugh Lovel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hugh had been farming this valley for more than twenty years and had turned a rocky creek bottom into one of the most fertile farms in the country—with compost, biodynamics, cover crops, and permanent grass and clover pathways between his vegetable beds. In the spirit of a true biodynamic farmer, Hugh produced everything he needed to sustain himself on his land, and I tried to follow in his footsteps. I managed the farm for most of my time there; I learned how to hand-milk cows and goats, make cheese and yogurt, grow rice, raise pigs, pickle okra, and save seeds. Hugh showed me how to build doughnut-shaped compost piles with manure and bedding from the animals. Compost from chickens would go to fruiting crops; cows, to leafy greens; goats, to herbs and flowers; pigs, to potatoes. I learned about radionics: influencing energetics through frequencies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Prep making, planting with the moon, stirring, spraying, and sharing knowledge with others are some of the actions that biodynamic farmers take to make their farms and communities thrive. While many of these techniques may seem pretty unorthodox, one thing that is very clear is that the farmer’s intention is the key to a well-managed farm. The goal is to be a good steward and leave the earth in better shape than we find it. Through Hugh, I became convinced that biodynamics provides a handful of very powerful tools for doing this and, at the same time, gives the citizen farmer’s intention a vehicle for action.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarbp"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/commonb.jpg",
      "width": "16"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3s"
  }, [_c('strong', [_vm._v("COMPOST MEDITATION: COMPOST FOR THE SOUL")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have learned that, when applied metaphorically, composting can help us thrive in any environment we are planted in—be it the boardroom, classroom, or family dinner table. When building a compost pile, I like to turn the rhythm of shoveling into an internal meditation that allows me to compost negative thoughts into positive ones: fear into faith, judgment into compassion, insecurity into confidence, and anger into love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Composting for the soil is the process of breaking down organic materials, while composting for the soul is the process of breaking down personal struggles (grudges, frustration, stress, anger). You bring the problems to the surface, add the good stuff to the heap (honesty, communication, support, nurturing), and give it time to “cook.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Building a compost pile is a meditation unto itself. Identify the location for the new pile by scratching a circle or square to mark the periphery. Loosen up the soil with a digging fork and add a sprinkling of lime, ash, and blood meal. As you build the pile, let your mind go and just tune into the rhythm of shoveling back and forth. It is an active meditation that results in a radiant pile of decomposing organic matter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even after this compost meditation is over, I use composting imagery frequently to dispel the mental clutter that may be holding me back in areas of my life beyond the garden. It has helped me make peace with business partners I’ve fallen out with, move on from stagnant relationships, remove obstacles impeding the creative process, and replace stress and anxiety with joy and gratitude—just like composting turns stinky raw manure and rotten vegetables into rich, sweet-smelling, fertile soil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the old Chinese proverb goes, a bad farmer grows weeds, a good farmer grows crops, and a great farmer grows soil. Be a great citizen farmer and make compost for a better life and a healthier planet!")])]), _vm._v(" "), _c('p', {
    staticClass: "image-b",
    attrs: {
      "id": "ch01image3"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0027-01.jpg",
      "width": "437"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-a",
    attrs: {
      "id": "ch01image2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0028-01.jpg",
      "width": "437"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('strong', [_vm._v("MOST COMMONLY USED TOOLS")])]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "34",
      "src": "images/f0029-01.jpg",
      "width": "150"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Don’t know the difference between a dibber and a digging spade? Thought a hori-hori was a type of sushi, not a garden tool? Never knew that a small hand shovel was called a trowel? Don’t throw in the towel on tools! I’ll help you learn what’s what, and what you really need, from indoor gardening to market farming.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("INDOOR GARDEN:")])]), _vm._v(" If your idea of gardening is a few pots of herbs by the kitchen window, you really just need a dedicated spoon for adding a little organic fertilizer every now and then, and perhaps some little scissors for snipping herbs for your culinary creations or morning teas. (If you’re into indoor hydroponics, however, that’s a different story!)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("BACKYARD GARDEN:")])]), _vm._v(" If you’ve made the move outside your kitchen door, you could use a few gardening tool basics. These include a trowel, a garden fork (for tossing compost or digging potatoes), a spade, a hoe, a cultivator (that curved-tine tool), pruners, a wheelbarrow or big bucket for removing garden debris and moving compost, a garden rake for smoothing beds and raking leaves for mulch, and let’s not forget gloves! In fact, two pairs would be best—one light pair for general garden work, and a heavier pair for handling things with thorns and tougher chores.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("COMMUNITY GARDEN:")])]), _vm._v(" If you’re helping start a community garden, you’ll need all the backyard tools listed above (and probably several of each) as well as basic building tools—a power drill, a saw, a hammer, a level, and a tape measure—to build garden beds, trellises, benches, sheds, and fences (add a post-hole digger for those). If you are growing food directly in the existing soil (rather than in raised beds), you will probably want to loosen up the soil with a tiller. Depending on how big your community garden is, you may find a direct seeder handy as well, especially if you are growing in long rows.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MARKET FARM:")])]), _vm._v(" Once you move up to a market farm, where you are selling what you grow, you will probably have less community help and will want to automate things more. Now is the time for a tractor with attachments to create and turn rows quickly and easily, as well as specialized harvesting tools, depending on your crop mix and growing system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Good-quality gardening tools and equipment are an investment. Get the best you can afford and take good care of them. Wooden handles need regular lubricating with linseed oil, mechanical parts need regular checking, and all tools and equipment should be stored properly so they don’t age prematurely from exposure to the elements. See if your city offers free or affordable access to a shared tool bank, or work with your network to establish one so that more people can take advantage of helpful small-scale gardening and farming tools.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarg"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "20",
      "src": "images/commong.jpg",
      "width": "19"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3s"
  }, [_c('strong', [_vm._v("TOOLS FOR COMPOSTING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Composting requires a great deal of tossing and turning, as well as spreading and incorporating. Having a few heavy-duty tools will make this process less backbreaking and more productive and enjoyable. There are some very cheap, shoddy tools out there in the mass market that are tempting because of their price, but I encourage you to make an investment in quality tools that will last. You will find that not only is it a better investment in the long term, but it also makes the job at hand easier and more fun.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SHOVEL:")])]), _vm._v(" For the most part, when making compost, any old shovel will do. For tumbler composting, I prefer a short-handled shovel to make it easier to get into tight areas, especially those with small openings. A long-handled shovel works best for bigger piles and wood bins. It is important to jab at the veggies in the compost pile to cut them into smaller pieces so they can break down faster. A standard hardware store shovel can cost between $15 and $40. If you want to invest in one that will last decades and inspire you to get more done in the garden, I recommend spending closer to $100 on a shovel with a forged-steel head and a sustainable hardwood handle with a T-grip.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("COMPOST/MANURE FORK:")])]), _vm._v(" Also called a hayfork, this tool is great for tossing and turning compost, as it allows you to grab a large amount of material per scoop. A digging fork, which is a more common home garden tool, will get the job done but will require more effort.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("LAWN AND LEAF RAKE:")])]), _vm._v(" A rake is useful for many tasks around the garden. A good leaf rake is a must for gathering the leaves that fall on your property so you can collect them for compost or mulch. It is also important to rake leaves so they do not kill off the grass below.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SOIL RAKE:")])]), _vm._v(" A steel-head rake is useful for spreading compost out over your garden beds and for raking up mowed cover crops or garden refuse. This tool is great for preparing the soil in a bed before planting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("WHEELBARROW:")])]), _vm._v(" There is no more efficient way to schlep compost and mulch all over the place than a good old-fashioned wheelbarrow. If a standard wheelbarrow is too much to handle, try a two-wheel wheelbarrow or a garden cart for more stability.")]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "129",
      "src": "images/f0031-01.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("COMPOST CADDY:")])]), _vm._v(" I know all of you are already collecting or are about to start collecting the kitchen scraps you accumulate from the yummy veggies you are eating every day. When you pick them yourself from your garden, there is even more to collect, such as the tops of carrots and excess leaves and roots that are cleaned off of grocery-store produce. An easy way to collect your kitchen scraps is on the counter near your cutting board and sink—this is where a compost caddy comes in. There are small, large, metal, ceramic, and even bamboo types available nowadays. I recommend metal or ceramic, definitely with a replaceable filter. If you eat a lot of veggies like we do, or have a family of four or more, I suggest a large size. These range from $20 to $60. For a more economical approach, a coffee can or bucket will do.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("COMPOST AERATOR:")])]), _vm._v(" Aerating your compost pile is important for speeding up the process and keeping the pile from going stagnant. While aerating can be done with a shovel or digging fork, a compost aerator is a handy tool for burrowing down deep in the pile with less effort. It is basically a long handle with some folding wings at the bottom. It is quite effective for home-scale composting and only runs about $20.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("COMPOST THERMOMETER:")])]), _vm._v(" If you are serious about making good compost, you need to get your pile up to at least 130°F. The best way to know if you are getting close is to use a compost thermometer, which is a thermometer on a long rod. A decent one costs between $20 and $30. You can also poke a deep hole into the pile with a tool handle and reach down with your hand to feel the heat.")])]), _vm._v(" "), _c('h3', {
    staticClass: "h3a"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('strong', [_vm._v("WHERE TO COMPOST")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here are a few things to consider when planning where to put your compost pile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SHADE:")])]), _vm._v(" Compost is best done in a partially shaded area, especially during the hot summer months, to prevent the pile from drying out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("WATER:")])]), _vm._v(" Place compost piles where they are exposed to rain and close to a water source, but not under a gutter, where they could get overwatered.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("ACCESS:")])]), _vm._v(" You will probably be visiting your compost pile on almost a daily basis, so put it somewhere close to the kitchen for easy access but don’t get too close or you may attract fruit flies and other insects into your home. Also keep in mind where your finished compost will be hauled to—most likely your veggie garden, which is ideally close by and not up a big hill or stairs from your compost. Lastly, make sure there is enough room around your pile to get in with a pitchfork to turn the pile every month or two. If you use a tumbler, make sure there is plenty of room to load, turn, and unload.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("ODOR:")])]), _vm._v(" Sometimes compost can get stinky, so putting it near the front door or patio where you dine may not be a good idea. To minimize odor, add plenty of carbon and make sure the pile doesn’t get too wet or dry.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CRITTERS:")])]), _vm._v(" Where there is compost, there are likely to be all kinds of critters: flies, ants, roaches, rats, cats, and even raccoons. Keep your pile well balanced to minimize the odor, which attracts many of these visitors, and try to eliminate hiding places around the pile. Using a rodent-proof compost bin will help prevent many of these issues.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("DRAINAGE:")])]), _vm._v(" It is best to put your compost pile on well-drained soil.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("COMPOST SYSTEMS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is a composting solution for everyone. Nowadays there are many compost systems—small and large, simple and complex—for every situation. Here are some common composting systems to consider for your home, school, workplace, or community.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("OPEN-PILE SYSTEM:")])]), _vm._v(" The most basic option is not to have a bin at all, but instead use the carbon materials themselves to form a container. Hay bales work well, or you can just use straw or leaves layered with animal manure for the outside wall of the pile and put all your decomposing vegetables in the middle. Some people like to surround a pile like this with chicken wire or a plastic compost bin to keep it more contained.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("WOOD AND/OR WIRE BIN:")])]), _vm._v(" If you’ve got access to some old pallets, you can make a thrifty and functional bin. In our wood shop, we build and sell bins that are both sturdy and stylish, using untreated FSC red cedar with a hinged lid and removable slats on the front for easy turning.")]), _vm._v(" "), _c('p', {
    staticClass: "image-ba"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0033-01.jpg",
      "width": "437"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("THREE-BIN SYSTEM:")])]), _vm._v(" If you’re impatient with how slowly the composting is going, consider trying a two-or three-section system. Toss your compost pile with a pitchfork from one open bin to the next every month or two in order to add air and to speed decomposition.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("TUMBLER:")])]), _vm._v(" If you want to step things up, consider getting a closed composter that spins. This is an easy, popular choice for home and school gardens, and an excellent way to compost kitchen scraps in an urban environment. These clever devices make turning the compost almost effortless. Rather than requiring a pitchfork to flip your pile from one bin to another, the tumblers are spun or rolled to mix and aerate the ingredients. I prefer the ones with two chambers; that way the material in one chamber, once full, can break down without new raw material being added. Another advantage to the tumblers is that most of them are rodent-proof. They should have ventilating air holes, which are important for good composting, but do not allow vermin to get inside.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("WORM BINS:")])]), _vm._v(" Worm bins are fun, easy, and productive, and the finished “vermicompost” does wonders for your garden (and boosts germination for certain crops like you wouldn’t believe). Worms are little munchers, so they prefer their meals finely chopped. Juice pulp is caviar for worms! The problem some people have with worm bins is overfeeding the little guys. Yes, they eat half their weight in pounds per day, but it’s best if you take it slow and see what that really means before laying out a daily buffet. There are many worm bin options out there—some homemade, and some worm condos that are pretty high-tech. We build wooden worm bins and also sell a lot of the stackable recycled plastic ones that have a spigot for capturing the worm tea, a nutrient-rich liquid that accumulates in the worm bin and is very good for your plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("ELECTRIC COMPOSTERS:")])]), _vm._v(" Marketed especially to urban dwellers, these plug in and provide automatic turning, heat, and aeration. They’re pretty slick, and also pretty expensive (about $300). But if you live in a condo and have no outdoor space, they may be well worth the investment; they can go inside or on a patio. They can also be used for composting pet feces! Do not use that compost on your veggies, though—just on flowers and landscaping.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("BOKASHI:")])]), _vm._v(" This composting technique is gaining popularity. Bokashi is a culture that ferments food scraps into compost; it works wonderfully, especially in urban environments. It’s as simple as a setting up a bucket or barrel with the bokashi culture and adding your food scraps.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("GRUB COMPOSTING:")])]), _vm._v(" This grub-based system uses black soldier fly larvae to convert kitchen scraps and "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("manure both into usable compost and into feed for poultry, fish, and other animals. These larvae will often appear naturally in compost piles and can also be bred and harvested using systems designed for this purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("HUGELKULTUR:")])]), _vm._v(" This age-old German technique utilizes woody debris to create a heap that is covered with soil and then planted. This is a great way to transform yard waste such as grass clippings, twigs, branches, and leaves into a vibrant raised garden bed. These beds hold moisture well and help with drainage, especially on compacted soils. They also serve as happy homes for beneficial microorganisms and thus healthy plants.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Some things you can throw into your hugel bed include:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Branches of all sizes")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Leaves")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Grass clippings and hay")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Kitchen scraps")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Compost (even if not fully broken down)")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Soil")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Bark or wood chips")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Newspaper and cardboard")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Do "), _c('em', [_vm._v("not")]), _vm._v(" add any treated wood, plastic products, or any of the following types of wood:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Black cherry")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Black walnut")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Black locust")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Cedar")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("To build a pile, simply layer the ingredients in whatever size and shape you desire, placing the bigger stuff on the bottom. Cover with soil and compost and pack the bed down as densely as you can—and you’re ready to plant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CURBSIDE COMPOSTING:")])]), _vm._v(" If you happen to live in a progressive city like Portland, Seattle, or San Francisco, you can separate your organics, put them in a curbside waste bin alongside your garbage and recycling bins, and clean your hands of the composting process altogether. While this is a nice service, I still recommend making your own compost so you can complete the nutrient cycle in your own landscape and experience firsthand the exciting process that makes many a gardener proud.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("LARGE-SCALE COMPOSTING:")])]), _vm._v(" If you have a business such as a restaurant, or if you work in a school or hospital, there are plenty of composting options for you to get involved in as well. There are large in-vessel composting systems designed to be placed behind schools or grocery stores. Some cities have compost pickup services that take food scraps to a commercial compost facility, where they are composted and sold to farmers, gardeners, and landscapers. If you are building a pile in a large backyard or on a small farm, a rectangular pile 6 feet wide by 6 feet tall by 20 feet long is a good standard size and is perfect for one set of biodynamic compost preparations. If you want to build a larger pile, I recommend that each pile be 6 to 10 feet wide, 8 feet tall, and up to 200 feet long.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("HUMANURE:")])]), _vm._v(" For the hard-core composter who wants to let nothing go to waste, humanure is the result of composting human feces and urine with sawdust and paper or other carbon sources. So long as the compost "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("process reaches temperatures that destroy harmful pathogens (above 130°F for at least 72 hours), this finished compost can be used to grow both edible and inedible plants. Well-composted humanure is not to be confused with sewage sludge, which can contain heavy metals and pathogens.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("COMPOST RECIPE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All ingredients that go into a compost pile should be natural and organic; “if it grows it goes” is a simple rule of thumb to follow. The most available compost ingredients in an urban area are leaves and woody material (best shredded) for carbon, and grass clippings (without chemical sprays) and vegetable scraps for nitrogen. If you can get your hands on some chicken, cow, horse, or rabbit manure, that will help. Rabbits and chickens are great for backyards and both produce rich manure for composting. Rabbits are the easiest; you can put hutches above ground with worm bins below and create rich rabbit-worm compost in no time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ratio of carbon (C) to nitrogen (N) is very important for a healthy compost pile. The C:N ratio should be about 25 parts carbon to 1 part nitrogen. While mixing carbon and nitrogen materials for composting is a very basic concept, the science behind it is complex and dynamic. Carbon brings form to things in nature; think about your bones, or the structure of a plant. Nitrogen is more like the energy running through the forms: pulse, will, and desire. When rich carbon and nitrogen materials are combined with intention, the foundation for future life forms arises. But if they are left alone they can become toxic. For example, raw manure without a carbon source like hay can smell foul and pollute the environment. Good compost, however, does not smell bad. Likewise, when the human body is healthy it should smell only on the inside, not on the outside, as Rudolf Steiner explains in his Agriculture Course.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Not all ingredients for making compost have the ideal 25:1 ratio, so a little mix-and-match is necessary. If there is too much carbon, the pile will be stagnant, and if there’s too much nitrogen it will get stinky and wet. Here is a simple way to balance the C:N ratio in your compost pile:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" High C:N ratios can be lowered by adding nitrogenous materials like grass clippings or manures.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Low C:N ratios can be raised by adding carbon materials like dry leaves, wood chips, or paper.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Piles in humid regions may need a little protection from the rain, such as being under a tree or canopy.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Piles in arid regions, on the other hand, should be built with a concave top to catch as much water as possible.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('strong', [_vm._v("WHAT MAKES COMPOST WORK?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While humans are the stewards who facilitate composting, it is the microorganisms—including bacteria, fungi, actinomycetes, protozoa, and rotifers—that deserve the credit for making the process happen. In order to create a healthy and productive workplace for our noble bugs, the following things need to be fostered in your compost pile:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CARBON")])]), _vm._v("–energizes the pile and produces heat due to its microbial oxidation. Carbon materials are typically brown and dry.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("NITROGEN")])]), _vm._v("–feeds the microorganisms that are busy oxidizing the carbon. Nitrogen materials are typically wet and green; they also include colorful fruits and veggies and animal manures.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("OXYGEN")])]), _vm._v("–oxidizes the carbon and fuels the decomposition process.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("WATER")])]), _vm._v("–needed in the right amounts to maintain the microbial activity without causing the pile to go anaerobic.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch01-page1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('strong', [_vm._v("COMPOST INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here is a general list of carbon, nitrogen, and neutral sources for your compost, as well as important guidelines on what should always, never, and sometimes be added to your compost pile.")]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0038-01.jpg",
      "width": "486"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "106",
      "src": "images/f0039-01.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imaget"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "265",
      "src": "images/f0039-02.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "197",
      "src": "images/f0039-03.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-ba"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0040-01.jpg",
      "width": "437"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('strong', [_vm._v("KNOW YOUR POO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In biodynamics, the farm or garden is treated as a self-contained living organism that provides its own fertility through animal manures and cover crops. Having the right balance of animals and crops helps ensure the soil is replenished year after year. Animals process grass into manure, which, when returned to the soil in the right way, provides it with the perfect medicine: nutrient-rich organic matter. Manure should be well composted before being applied to the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("This is a list of some common farm animals and what their composted manure is best for growing:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CHICKENS:")])]), _vm._v(" Chicken manure compost is high in nitrogen, phosphorus, and potassium, making it an excellent choice for fruiting vegetables like tomatoes, peppers, and squash.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("GOATS:")])]), _vm._v(" I have found goat manure to be most effective on herbs and flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("PIGS:")])]), _vm._v(" Pig manure is perfect for potatoes and leeks due to its high potash and phosphorus contents.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("COWS:")])]), _vm._v(" Cow manure is great for growing just about everything due to its balanced nutrient content, but in my experience it is best used for leafy green vegetables such as lettuce, kale, and collards.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("RABBITS:")])]), _vm._v(" Rabbit manure is high in nitrogen and is also good for leafy greens.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("COMPOST BOOSTERS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If you find your compost is not hot to the touch or a thermometer shows a temperature below 110°F, you should either turn the pile or add a nitrogen source or other biological stimulants to get it kicking. You can use any high-nitrogen organic fertilizer like blood meal, feather meal, or chicken manure to help give your compost a boost. You can also find some good prepackaged options—labeled as either “compost starters” or “compost activators”—at a local garden center, in a hardware store, or online. Another option that has been growing in popularity is bokashi, which is a fermented compost activator made from inoculating wheat germ or sawdust with Effective Microorganism (EM). When added to compost, bokashi helps speed up the decomposition process. My favorite boosters are the biodynamic Pfeiffer Compost Starter, backyard chicken manure, and homegrown comfrey.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("BUILDING THE PILE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Start by identifying the area where you want to build your pile. With a digging fork or rake, scratch out a circle, square, or rectangle to mark the periphery of the new pile. Loosen the soil in that area and begin by layering browns and sunflower stalks, thistles, and other plants with hollow stems, but nothing woody.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("Start building up the outer periphery with a 1-foot-wide band of material until it’s about 1 foot high. I like to build piles in circles and usually go with a 5- to 7-foot diameter. Once you have built a base that is 12 to 20 inches wide by 1 to 2 feet tall, you are ready to start filling in the center a little bit at a time, making sure the outer wall is always at least 12 inches taller than the doughnut hole in the middle. This allows you to build a tall, strong pile. Here is a general sequence of materials to be layered:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("CARBON / BROWN MATTER")])]), _vm._v("–12 inches")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("NITROGEN / GREEN MATTER AND MANURES")])]), _vm._v("–6 inches")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SOIL")])]), _vm._v("–2 inches")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Add a layer of food scraps as part of the green matter, but keep these to the middle of the pile to avoid attracting animals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As you layer the ingredients, use the back of your pitchfork or shovel to tamp the sides and top of the pile. Compressing the pile so the ingredients are dense helps get the pile cooking. You can hop on top of the pile and do a little “tamp dance” and then gently but thoroughly shower the pile with water.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("ADDING THE BIODYNAMIC COMPOST PREPARATIONS TO THE PILE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just as people add vitamins to their diets, biodynamic farmers add herbal preparations to their compost. Herbs such as chamomile, dandelion, yarrow, stinging nettle, and valerian are prepared according to the recipes in Steiner’s Agriculture Course to best impart their healing properties into the compost pile. When these potent herbs are added to the heap, a certain physical and energetic healing takes place, enlivening the compost with microbes and forces that are beneficial to soil, plants, and animals. You can make biodynamic compost preparations at home or on your farm (see "), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/resources#resources-page1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("this page")]), _vm._v(" or refer to a local, national, or international biodynamic association) or a set can be purchased for about $25 from a few sources including local biodynamic farmers and the Josephine Porter Institute. One set of preparations (or “preps”) can treat up to fifteen tons of compost, which is plenty for a very large backyard pile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When your compost heap is built, follow these simple steps:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Make five holes in the top of the compost heap, about halfway into the depth of the pile, distributed in an “x” pattern like the shapes on a number five playing card. The instructions that come with the preparations will provide more detail on how and where to insert the preps into the pile.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Put 1 gram each of the BD 502-506 preps in the holes about halfway down into the pile, using one prep per hole. Fill in holes.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Make a hole at each end of the heap. Stir 10 ml of BD 507 (valerian) in 1 liter of water for 10 minutes and pour half of the liquid into this hole.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Sprinkle the remaining liquid evenly around the top of the pile in a clockwise direction.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Spray pile with BD 508 (fermented equisetum tea) and toss equisetum plants on top of the pile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Maintain the pile:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Measure the heat periodically: Insert a compost thermometer or dig into the heap with your hands or a shovel to see if it’s steaming.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Water regularly.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("TENDING YOUR COMPOST PILE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’ll tell you a simple secret: Compost happens. Things in nature decompose. If you pile some leaves and plant cuttings in the corner of your yard, they will break down naturally and you will have compost one day, whether you toss it every week or leave it alone. The difference will be the speed with which this happens and the quality of the finished product. Keep your compost pile moist and aerated by watering it when it is dry and turning it when it becomes wet or stagnant. If your pile gets hot, it will break down faster and will be less likely to have weed seeds or disease. If it stays cool, introduce worms and give it some more time to decompose.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("TROUBLESHOOTING")])]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("1.")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("COMPOST PILE NOT HEATING UP:")])]), _vm._v(" To achieve the ideal temperature for quick composting, and also to kill weed seeds, you need at least a 3-foot-by-3-foot pile, with the right ratio of carbon (about 70 percent) to nitrogen (about 30 percent), plus sufficient air (turn the pile once a month) and water (slightly damp, not soaked). If your pile is not producing at the rate you want, you may need to adjust these components to get your desired results.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("2.")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("COMPOST PILE NOT BREAKING DOWN:")])]), _vm._v(" All garden debris will eventually decompose, but if the pieces you include in the pile are too big, it might take a very long time. You can help the process along by chopping up veggies, big stalks, or branches and shredding leaves before adding them. Many people actually have a separate pile, such as a brush pile or hugelkultur bed, for larger debris like tree branches.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _c('span', {
    staticClass: "red"
  }, [_vm._v("3.")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("ODORS AND RODENTS:")])]), _vm._v(" Tossing kitchen scraps in an open compost pile without burying them is an open invitation for every rat, squirrel, and raccoon in the vicinity to come for a feast. Make sure to cover food scraps with a thick layer of carbon material each time you add to your pile. But even if you do bury food scraps, some pests may still find their way to your pile. Investing in a closed, rodent-proof composter for your veggie and fruit peels is one solution. And, again, balancing the greens and browns will also reduce odor.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("4.")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("MAGGOTS:")])]), _vm._v(" Disgusting though they might be, maggots—the larvae of flies—are generally considered harmless and may actually be beneficial (especially the larvae of the black soldier fly) in helping reduce the volume of a manure pile. Some species, however, can be carriers of disease. Maggots thrive in excessive moisture, and if you’re using a closed bin without sun exposure, it’s very difficult to dry it out. Mixing in dry high-carbon material such as shredded cardboard helps, as does adding bone meal.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("5.")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("ANTS:")])]), _vm._v(" Ants in the compost pile could be a sign that your compost is too dry. Sprinkling cinnamon or turmeric is one deterrent. Add water to the pile and make sure your ratio of browns and greens is balanced.")]), _vm._v(" "), _c('p', {
    staticClass: "order"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("6.")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("WORM BIN GONE BAD:")])]), _vm._v(" If your worm bin smells, it probably means you’re overfeeding the worms and need to cut back on adding scraps. Another issue is worms that try to get out. This may be due to insufficient air (there should be airholes) or excessive moisture, which will basically drown them. It’s normal to give your worm bin an occasional reboot with a deep clean and fresh bedding.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("WHEN IS COMPOST READY TO USE?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Healthy, fertile soil should feel soft, light, moist but not wet, and crumbly in texture. It should smell earthy and sweet, with minimal to no ammonia odor. It should be teeming with life—in the form of worms, bugs, and microorganisms. If it was made with food scraps, the only things you should be able to distinguish are bits of eggshell, sticker labels, and avocado or mango seeds.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("BUYING COMPOST")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When buying compost, remember that not all compost is created equal. Be careful of poorly made compost, which can be riddled with weed seeds, pathogens, diseases, heavy metals, and even human manure. It’s important that you know your composters and what their practices are to ensure that they are making a clean, high-quality product. Read the ingredients list and check to see if it is OMRI (Organic Materials Review Institute) certified or approved for use in organic agriculture. This means the compost has to have reached temperatures of over 135°F for a certain period of time, and that the finished product has been tested for pesticides, heavy metals, and other possible contaminants.")]), _vm._v(" "), _c('p', {
    staticClass: "image-ba"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0045-01.jpg",
      "width": "437"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('strong', [_vm._v("HOW TO USE COMPOST")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whenever I grow a garden or farm, there are a few ingredients that are essential to getting started. Once the chemistry of the soil is balanced using lime and other minerals, I add compost to feed the soil biology. This enhances nutrients, moisture retention, disease resistance, and overall plant vitality. If your compost is not fully ready but you need the bin space to start a new batch, empty the contents into a container with drainage and let it cure outside for a few weeks until ready for the garden. The best times to apply compost in the garden are late fall and early spring, as well as in between crop cycles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here are the primary ways I use compost in the garden and on the farm:")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Add finished compost to garden beds in between planting cycles and incorporate into the top 4 to 8 inches of the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Use finished compost as side dressing around the bases of plants, then water and mulch. This can be done for landscape plants and lawns as well as veggies, herbs, and fruit trees. The bigger the plant, the more compost should be used.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Use finished compost to inoculate a new or stagnant compost pile. Add a few shovelfuls to help kick-start a new pile.")]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("•")]), _vm._v(" Make compost tea and apply as a soil drench or foliar spray. Opposite is a compost tea recipe that can be made in small batches for home use as well as in a large-scale compost tea brewer for commercial applications. There are a few caveats before you begin: When making tea, be sure to use good compost and follow the National Organic Program’s safety guidelines. While unlikely, there is a chance that ingesting crops that have been treated with compost tea made incorrectly could lead to illness caused by coliform bacteria or salmonella.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("GROW YOUR OWN FERTILIZER: COVER CROPS AND GREEN MANURING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Between crop cycles I plant cover crops to let the land rest and to replenish nutrients and organic matter that were extracted by the previous crop. Once the cover crop reaches its highest nitrogen-fixing stage of growth, around peak flowering time, I will usually turn it back into the soil, which is called “green manuring.” Organic matter recycles into the soil and feeds the compost microorganisms and worms, which in turn feed the next crops planted here. This amazing process, like composting, is a natural, easy way to regenerate the soil and ensure a healthy garden for posterity. If you turn under the cover crop in the bed, wait two weeks to plant so that the organic matter has time to break down. Instead of turning under the cover crop, you can also harvest it and put it into your compost bin so you can plant in the garden right away.")]), _vm._v(" "), _c('div', {
    staticClass: "sidebaro"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "20",
      "src": "images/commono.jpg",
      "width": "21"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3s",
    attrs: {
      "id": "ch01-page2"
    }
  }, [_c('strong', [_vm._v("FARMER D COMPOST TEA")])]), _vm._v(" "), _c('h5', {
    staticClass: "h5s"
  }, [_c('strong', [_vm._v("MAKES 5 GALLONS, ENOUGH FOR A LARGE HOME GARDEN")])]), _vm._v(" "), _c('p', {
    staticClass: "left-s"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('strong', [_vm._v("1 CLEAN 5-GALLON (20-L) BUCKET (PREFERABLY CERAMIC OR STAINLESS STEEL. PLASTIC IS OKAY. NO BLEACH OR CHEMICAL RESIDUES.)")])])]), _vm._v(" "), _c('p', {
    staticClass: "left-s"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('strong', [_vm._v("4 GALLONS (15 L) RAINWATER, SPRING WATER, OR TAP WATER")])])]), _vm._v(" "), _c('p', {
    staticClass: "left-s"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('strong', [_vm._v("1 QUART (400 G) AGED COMPOST")])])]), _vm._v(" "), _c('p', {
    staticClass: "left-s"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('strong', [_vm._v("PANTYHOSE, CHEESECLOTH BAG, OR FINE-SCREEN COLANDER")])])]), _vm._v(" "), _c('p', {
    staticClass: "left-s"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('strong', [_vm._v("STINGING NETTLE OR BURDOCK LEAVES")])])]), _vm._v(" "), _c('p', {
    staticClass: "left-s"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('strong', [_vm._v("3 TABLESPOONS COMPOST TEA ACTIVATOR (SUCH AS UNSULFURED ORGANIC MOLASSES OR A READY-MADE ACTIVATOR SUCH AS GROWING SOLUTIONS COMPOST TEA CATALYST)")])])]), _vm._v(" "), _c('p', {
    staticClass: "left-s"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('strong', [_vm._v("SMALL FISH-TANK AERATOR PUMP WITH TUBING AND SEVERAL BUBBLERS OR AIR STONES TO PUMP OXYGEN INTO THE BUCKET OF WATER WITH COMPOST AND ACTIVATOR")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Fill the bucket with water. If using tap water, let it sit out for 24 hours to release chlorine. Place the compost in the pantyhose, cheesecloth bag, or colander. Fully immerse the compost in the water without allowing soil particles to get in the water. (You can also brew without a mesh bag and instead run the finished tea through a fine-mesh or cheesecloth strainer.) Toss in a few handfuls of fresh stinging nettles, burdock leaves, or other apropriate herbs and weeds for added benefits. Add the compost activator, turn on the aerator pump, and let brew for 24 to 48 hours. If you are not using an aerator, let sit for 5 to 10 days to allow for adequate fermentation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once brewed, compost tea has a short shelf life, so it should be applied as soon as possible, no later than 24 hours after being brewed. When using compost tea, dilute at 10 parts water to 1 part compost tea and apply as follows:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("FOLIAR APPLICATION:")])]), _vm._v(" Spray in morning or evening on underside of leaves on plants, shrubs, and trees.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("SOIL DRENCH:")])]), _vm._v(" Water new transplants or existing plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("LAWN:")])]), _vm._v(" Spray or run through your irrigation system.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _vm._v("Some of my favorite cool-season cover crops are rye, crimson clover, winter peas, and hairy vetch. For warm-season cover crops, I like iron and clay peas, Sudan grass, buckwheat, soybeans, and sunhemp.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("COMMUNITY COMPOSTING")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Composting is a great way to practice your citizen farmer skills by inspiring your neighbors and local business-people to follow your example.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Take note of those bulging leaf bags along your street. Next time you see the neighbors who put them there, say hello and ask if they’d mind you taking it off their hands for your home compost. You may find yourself sharing tips on composting, organic lawn care, and vegetable gardening. A nice way to say thank you—and maybe recruit some new citizen farmers—would be to bring them back a small sample of finished compost to use in their gardens or planters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You can raise awareness simply by initiating the conversation. Ask your friends, local chefs, and coffee-shop owners if they are composting their food scraps and coffee grounds. If they are throwing away their organic material, offer to take it off their hands (maybe even for a small fee). Give them a special bucket and have them fill it with organic material only (I recommend taking them the list of compostable materials from "), _c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01-page1"
    }
  }, [_vm._v("this page")]), _vm._v(", or—better yet—giving them a copy of this book!). Every few days have them leave the bucket outside where you can easily pick it up. You can either take the bucket and leave them a clean one, or dump the contents of the bucket into a large trash bin in your vehicle, wash out the bucket right there on site, and leave it for them to fill up again. Bring the food residuals back to your home compost pile and add lots of carbon, such as shredded bark, sawdust, or all those leaves you’ve collected from the neighbors. This could turn into a little business before you know it!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Work together with neighbors and friends to collectively compost at home, at school, at work, or in a community garden. Building, turning, and spreading compost is best done with other citizen farmers!")]), _vm._v(" "), _c('div', {
    staticClass: "sidebarpp"
  }, [_c('p', {
    staticClass: "center-t"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/commonf.jpg",
      "width": "16"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("TOP 10")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "15",
      "src": "images/commonf.jpg",
      "width": "16"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "h4a"
  }, [_c('strong', [_vm._v("PLANTS FOR MAKING COMPOST")])]), _vm._v(" "), _c('p', {
    staticClass: "centers"
  }, [_c('span', {
    staticClass: "white"
  }, [_c('strong', [_c('em', [_vm._v("Some crops have more left over for the microbes than others. These are some of my favorites for feeding the compost pile:")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebary"
  }, [_c('p', {
    staticClass: "orders"
  }, [_vm._v("1. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("COMFREY:")])])]), _vm._v(" If there is one crop you should grow specifically to make better compost, comfrey is it. It is a hardy perennial and medicinal herb that enriches and speeds up decomposition when added to a compost pile. It can also be used as mulch beneath your veggie plants and as a slug trap—place comfrey leaves around the garden near slug-prone crops.")]), _vm._v(" "), _c('p', {
    staticClass: "orders"
  }, [_vm._v("2. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("PEAS:")])])]), _vm._v(" While it is great to grow peas for their delectable little pods, their other asset is the plant and nitrogen-fixing roots that remain after you’ve harvested all the peas. Cut the plants above the root and toss it into your compost pile.")]), _vm._v(" "), _c('p', {
    staticClass: "orders"
  }, [_vm._v("3. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("CARROTS:")])])]), _vm._v(" Most people grow carrots for their sweet, nutritious roots, leaving the large, leafy tops as perfect fuel for the compost pile. This is an excellent use for those vitamin- and mineral-rich greens, unless you feel adventurous and want to chop them up finely and add them to a salad or coleslaw. Some other options are to make a carrot-top pesto, whip up a soup, or add the greens to a batch of gumbo z’herbes.")]), _vm._v(" "), _c('p', {
    staticClass: "orders"
  }, [_vm._v("4. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("TOMATOES:")])])]), _vm._v(" At the end of each summer season, tomatoes are likely to be the tallest, leafiest mess left in the garden. The semi-woody stems make a great base for a compost pile so long as they are not diseased. (It’s better to play it safe with diseased plants and throw them away.)")]), _vm._v(" "), _c('p', {
    staticClass: "orders"
  }, [_vm._v("5. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SWEET POTATOES:")])])]), _vm._v(" All the vines that are left after harvesting a crop of sweet potatoes are an excellent addition to compost, as the greens are high in vitamins and minerals. You can eat the tips of the greens by picking the top 3 to 5 inches of the vines and adding them to a stir-fry or soup. If the stems don’t snap off easily, try moving closer to the tip until they do.")]), _vm._v(" "), _c('p', {
    staticClass: "orders"
  }, [_vm._v("6. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("BEANS:")])])]), _vm._v(" Both bush and pole beans have a good deal of plant matter left after harvest. As with peas, it is best to leave the nitrogen-fixing roots in the soil and add the rest of the plants to the compost pile.")]), _vm._v(" "), _c('p', {
    staticClass: "orders"
  }, [_vm._v("7. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("STINGING NETTLE:")])])]), _vm._v(" While you may not want to plant this everywhere in your garden because of its stinging spines, you will definitely benefit from having a patch you can pick for food, tea, and compost. Stinging nettle is extremely high in iron, magnesium, calcium, and vitamins, which are imparted to the soil through compost made with nettles. Also makes a fantastic compost tea that can attack a pest outbreak if applied at first sighting.")]), _vm._v(" "), _c('p', {
    staticClass: "orders"
  }, [_vm._v("8. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("HAIRY VETCH:")])])]), _vm._v(" A great cool-season cover crop that fixes nitrogen in the soil and produces a great deal of organic matter. I usually grow hairy vetch together with rye and winter peas, which together make a rocking green manure or nitrogen layer in your compost pile.")]), _vm._v(" "), _c('p', {
    staticClass: "orders"
  }, [_vm._v("9. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("GRASSES:")])])]), _vm._v(" Growing perennial grasses in your pathways and lawn and annual grasses in your garden beds is a good way to draw nutrients up from deep in the soil, prevent erosion, and have a nice continuous harvest of grass and clover clippings to feed to animals and/or the compost pile.")]), _vm._v(" "), _c('p', {
    staticClass: "orders-1"
  }, [_vm._v("10. "), _c('span', {
    staticClass: "small"
  }, [_c('strong', [_c('span', {
    staticClass: "blue"
  }, [_vm._v("SUNFLOWERS:")])])]), _vm._v(" Sunflowers in the garden provide both beauty and function. While they are very useful for trellising crops like cucumbers and pole beans, they also grow tall and fast, providing lots of organic matter for compost. Their big stalks are best used at the base of a compost pile; crosshatch them to help draw air up into the heap.")])]), _vm._v(" "), _c('p', {
    staticClass: "image-ba"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "height": "550",
      "src": "images/f0050-01.jpg",
      "width": "439"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0